import React, { useEffect, useState } from 'react'
import Typography from '@mui/material/Typography';

const AboutUs = props => {
    const { community } = props
    return (
        <div>
            <Typography variant="h6" component="h2">
                I a nutshell
            </Typography>
            <Typography variant="body2">
                {community?.description}
            </Typography>
            <Typography variant="h6" component="h2" sx={{ marginTop: '30px' }}>
                About {community?.name}
            </Typography>
            <div dangerouslySetInnerHTML={{ __html: community?.promotional_text }} />

            {community?.rules && <div>
                <Typography variant="h6" component="h2" sx={{ marginTop: '30px' }}>
                    Community Rules
                </Typography>
                <div dangerouslySetInnerHTML={{ __html: community?.rules }} />
            </div>
            }


        </div>

    )
}

AboutUs.propTypes = {}

export default AboutUs
